/**
 * Runtime target tag. The same React bundle ships to all four; the tag picks
 * which platform-specific wiring to apply (auth, API base URL, native bridges).
 */
export const Platform = {
  Web: 'web',
  Discord: 'discord',
  Tauri: 'tauri',
  Capacitor: 'capacitor',
} as const;
export type Platform = (typeof Platform)[keyof typeof Platform];
